import React from 'react';
import Modal from 'react-responsive-modal';
import moment from 'moment';
import _ from 'lodash';
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import Translate from 'translate';

class TokenModalAPU extends React.Component {
  constructor( props ) {
    super( props );
  }

  render() {
    const { data, onClose, open, dateFormat } = this.props;

    return (
      <Modal little
             modalClassName="col-md-6 client-folder p-0"
             open={open}
             onClose={onClose}>

        <div className="p-3 mb-4 bg-blue">
        <h5 className="m-0 d-inline-block">{_.get( data, 'MovementType' ) ? _.get( data, 'MovementType' ) : '-'} - {_.get( data, 'DocNumber' ) ? _.get( data, 'DocNumber' ) : ''}</h5>
        </div>

        <div className="row mb-3 px-3">
          <div className="col-md-5">
            <p className="mb-1"><b><Translate id="date"/>:</b> {_.get( data, 'Date') ? moment(data.Date , "YYYY-MM-DD" ).format( dateFormat ) : '-' }</p>
            
          </div>
          <div className="col-md-3">
            <p className="mb-1"><b><Translate id="Amount"/>:</b> {_.get( data, 'Amount', '-' )}</p>
          </div>
          <div className="col-md-4">
            <p className="mb-1"><b><Translate id="Balance"/>:</b> {_.get( data, 'Balance', '-' )}</p>
          </div>

        </div>
      </Modal>
    )
  }
}
const mapStateToProps = ( state, ownProps ) => ( {
  locale: state.settings.locale,
  dateFormat: state.settings.dateFormat,
  externalCustomer: state.settings.externalCustomer,
} );
export default injectIntl( connect( mapStateToProps )( TokenModalAPU ) );



// WEBPACK FOOTER //
// ./routes/app/components/Agent/ClientFolder/TokenModalAPU/index.js